/* eslint-disable */
var baseApiUrl = ''
if (process.env.NODE_ENV === 'production') {
  // This will be replaced with the server endpoint for demo purposes
  baseApiUrl = 'https://vscp-api.geodemosolutions.com/public/'
 }
else {
  baseApiUrl = 'http://localhost/vscp-api/public/'
  // baseApiUrl = 'http://localhost:8000/'

}

export {
  baseApiUrl
}
